// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"unfold-more"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 15L12 19L8 15M16 9L12 5L8 9","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UnfoldMoreIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'unfold-more',
    ref,
    icon: element,
  },
));

UnfoldMoreIcon.displayName = 'UnfoldMoreIcon';

export default UnfoldMoreIcon;
